import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const AccountSidebar = ({ user, isOpen, onClose }) => {
  const location = useLocation();

  const navigationItems = [
    {
      label: 'Dashboard',
      path: '/user-account-dashboard',
      icon: 'LayoutDashboard'
    },
    {
      label: 'Order History',
      path: '/order-history',
      icon: 'Package'
    },
    {
      label: 'Wishlist',
      path: '/wishlist',
      icon: 'Heart'
    },
    {
      label: 'Addresses',
      path: '/addresses',
      icon: 'MapPin'
    },
    {
      label: 'Payment Methods',
      path: '/payment-methods',
      icon: 'CreditCard'
    },
    {
      label: 'Profile Settings',
      path: '/profile/edit',
      icon: 'User'
    },
    {
      label: 'Security',
      path: '/security',
      icon: 'Shield'
    },
    {
      label: 'Notifications',
      path: '/notifications',
      icon: 'Bell'
    }
  ];

  const isActivePath = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      {/* Mobile Overlay */}
      {isOpen && (
        <div 
          className="lg:hidden fixed inset-0 bg-black/50 z-40"
          onClick={onClose}
        />
      )}
      
      {/* Sidebar */}
      <div className={`
        fixed lg:static inset-y-0 left-0 z-50 w-64 bg-card border-r border-border transform transition-transform duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `}>
        <div className="flex flex-col h-full">
          {/* Mobile Header */}
          <div className="lg:hidden flex items-center justify-between p-4 border-b border-border">
            <h2 className="text-lg font-semibold text-foreground">Account Menu</h2>
            <button
              onClick={onClose}
              className="p-2 text-muted-foreground hover:text-foreground transition-colors"
            >
              <Icon name="X" size={20} />
            </button>
          </div>
          
          {/* User Info */}
          <div className="p-4 border-b border-border">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
                <Icon name="User" size={20} className="text-primary" />
              </div>
              <div>
                <p className="font-medium text-foreground">{user.firstName} {user.lastName}</p>
                <p className="text-sm text-muted-foreground">{user.email}</p>
              </div>
            </div>
          </div>
          
          {/* Navigation */}
          <nav className="flex-1 p-4">
            <ul className="space-y-2">
              {navigationItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    onClick={onClose}
                    className={`
                      flex items-center space-x-3 px-3 py-2 rounded-lg transition-colors
                      ${isActivePath(item.path)
                        ? 'bg-primary text-primary-foreground'
                        : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                      }
                    `}
                  >
                    <Icon name={item.icon} size={20} />
                    <span>{item.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
          
          {/* Footer */}
          <div className="p-4 border-t border-border">
            <Link
              to="/"
              className="flex items-center space-x-3 px-3 py-2 text-muted-foreground hover:text-foreground transition-colors"
            >
              <Icon name="HelpCircle" size={20} />
              <span>Help & Support</span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountSidebar;